// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__3sHes","header":"panel_header__2mRfR","content":"panel_content__1myLj"};